// Helper function to generate a UUID in v4 format.
// Uses the Crypto API's randomUUID() method if available, otherwise falls back
// to a manually generated UUID using Math.random().
export const generateId = () => {
    let user_id;
    if ("randomUUID" in crypto) {
        user_id = crypto.randomUUID();
    }
    else {
        user_id = "xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx".replace(/[xy]/g, (c) => {
            const r = (Math.random() * 16) | 0;
            const v = c === "x" ? r : (r & 0x3) | 0x8;
            return v.toString(16);
        });
    }
    return user_id;
};
